var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14480"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6381",
    d: "M8 0a7.984 7.984 0 1 1-8 7.984A7.992 7.992 0 0 1 8 0z",
    fill: "#fff",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6382",
    d: "M8.676 5.66a.623.623 0 0 1-.492-.2.7.7 0 0 1-.18-.479.951.951 0 0 1 .2-.629.6.6 0 0 1 .468-.246.652.652 0 0 1 .516.2.7.7 0 0 1 .18.479 1.011 1.011 0 0 1-.216.623.6.6 0 0 1-.476.252zM7.12 12.1a.929.929 0 0 1-.268-.054 2.583 2.583 0 0 1-.332-.132 1.472 1.472 0 0 1-.28-.173q-.12-.096-.12-.168a2.585 2.585 0 0 1 .1-.335q.1-.3.24-.731t.318-.934q.174-.5.33-.958t.276-.808q.12-.353.168-.473l-.636-.06-.784 1.137-.132-.1a5.1 5.1 0 0 1 .834-1.269 1.231 1.231 0 0 1 .834-.479.768.768 0 0 1 .282.066 1.371 1.371 0 0 1 .306.174 1.214 1.214 0 0 1 .24.234.407.407 0 0 1 .1.246 1.86 1.86 0 0 1-.09.365q-.09.293-.228.7t-.306.88q-.168.473-.324.9l-.276.754q-.12.329-.156.449l.588.084.84-1.066.108.1a4.632 4.632 0 0 1-.414.7 3.968 3.968 0 0 1-.442.511 2.048 2.048 0 0 1-.42.323.762.762 0 0 1-.356.117z",
    fill: "#182533"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/HelpIcon.d6702168.svg";
export { ForwardRef as ReactComponent };